import React from 'react'
import ReactDOM from 'react-dom/client'
import { BrowserRouter } from 'react-router-dom'
import { Toaster } from 'react-hot-toast'
import App from './App.tsx'
import './index.css'
import './i18n/config'

// Recover from stale lazy-route chunks after deploys (Vite + service worker)
window.addEventListener('vite:preloadError', (event) => {
  event.preventDefault()
  const storageKey = 'chunk-reload-attempted'
  if (sessionStorage.getItem(storageKey) !== '1') {
    sessionStorage.setItem(storageKey, '1')
    window.location.reload()
  }
})

// Service Worker Registration with Update Detection
if ('serviceWorker' in navigator) {
  // Register service worker
  window.addEventListener('load', () => {
    // Register service worker - cache headers in vercel.json ensure it's not cached
    navigator.serviceWorker
      .register('/sw.js')
      .then((registration) => {
        console.log('[SW] Service Worker registered:', registration.scope);

        // Check for updates every 5 minutes (more frequent for production)
        setInterval(() => {
          registration.update();
        }, 5 * 60 * 1000);
        
        // Also check immediately on page load
        registration.update();

        // Handle service worker updates
        registration.addEventListener('updatefound', () => {
          const newWorker = registration.installing;
          if (!newWorker) return;

          newWorker.addEventListener('statechange', () => {
            if (newWorker.state === 'installed' && navigator.serviceWorker.controller) {
              // New service worker available, notify user
              console.log('[SW] New service worker available');
              
              // Dispatch custom event for App to handle
              window.dispatchEvent(
                new CustomEvent('sw-update', { 
                  detail: { 
                    registration,
                    newWorker 
                  } 
                })
              );
            }
          });
        });

        // Listen for controller change only when user explicitly updates via the prompt
        // (avoid surprise reloads mid-navigation when a new service worker activates)
      })
      .catch((error) => {
        console.error('[SW] Service Worker registration failed:', error);
      });

    // Listen for messages from service worker
    navigator.serviceWorker.addEventListener('message', (event) => {
      if (event.data && event.data.type === 'SW_UPDATED') {
        console.log('[SW] Service worker updated to version:', event.data.version);
        // Dispatch event for App component to show update notification
        window.dispatchEvent(
          new CustomEvent('sw-update-available', { 
            detail: { version: event.data.version } 
          })
        );
      }
      if (event.data && event.data.type === 'SW_ACTIVATED') {
        console.log('[SW] Service worker activated:', event.data.version, event.data.message);
        if (event.data.version) {
          sessionStorage.setItem('sw-version', event.data.version);
        }
      }
    });
  });
}

ReactDOM.createRoot(document.getElementById('root')!).render(
  <React.StrictMode>
    <BrowserRouter
      future={{
        v7_startTransition: true,
        v7_relativeSplatPath: true,
      }}
    >
      <App />
      <Toaster 
        position="top-center"
        toastOptions={{
          duration: 4000,
          style: {
            background: '#363636',
            color: '#fff',
          },
        }}
      />
    </BrowserRouter>
  </React.StrictMode>,
)
